import { render, staticRenderFns } from "./DiplomadoSupervisorSsoma.vue?vue&type=template&id=95141406"
import script from "./DiplomadoSupervisorSsoma.vue?vue&type=script&lang=js"
export * from "./DiplomadoSupervisorSsoma.vue?vue&type=script&lang=js"
import style0 from "./DiplomadoSupervisorSsoma.vue?vue&type=style&index=0&id=95141406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports